import {useSelector} from 'react-redux';
import {TablesState, TableState} from './actions';
import {useContext} from 'react';
import {TableContextContext} from './createTableContext';

export default function useTableState<TSelected>(tableSelector: (state: TableState) => TSelected) {
  const {name} = useContext(TableContextContext);
  return useSelector<{table: TablesState}, TSelected>(({table}) => (table[name] ? tableSelector(table[name]) : null));
}
